import { Sheet } from 'react-modal-sheet'
import BottomSheet from '~components/ui/bottom-sheet'
import Icon from '~components/ui/icon'
import { SelectBoxData } from '~containers/app/ask-a-vet/types'
import { cn } from '~utils/cn'

interface SelectExtraOptionsBottomsheetProps {
  data: SelectBoxData[]
  open: boolean
  onCloseRequest: () => void
  value: SelectBoxData['value']
  onSelect: (data: SelectBoxData) => void
}
const SelectExtraOptionsBottomsheet = ({
  data,
  open,
  onCloseRequest,
  value,
  onSelect,
}: SelectExtraOptionsBottomsheetProps) => {
  return (
    <BottomSheet isOpen={open} onCloseRequest={onCloseRequest}>
      <Sheet.Scroller>
        {data.map((item, index) => (
          <SelectOptionItem key={index} data={item} value={value} onSelect={onSelect} />
        ))}
      </Sheet.Scroller>
    </BottomSheet>
  )
}

interface SelectOptionItemProps {
  data: SelectBoxData
  value: SelectBoxData['value']
  onSelect: (data: SelectBoxData) => void
}
const SelectOptionItem = ({ data, value, onSelect }: SelectOptionItemProps) => {
  const isSelected = value === data.value

  return (
    <div
      role="menuitem"
      tabIndex={0}
      className="relative w-full cursor-pointer py-3 text-body-1 text-gray-900 flex items-center justify-between px-4 h-[48px]"
      onClick={() => onSelect(data)}
      onKeyDown={() => onSelect(data)}
    >
      <span
        className={cn(
          'text-gray-900 text-body-1 dark:text-gray-500',
          isSelected && 'dark:text-white'
        )}
      >
        {data.label}
      </span>
      {isSelected && (
        <Icon
          name="check_mark"
          className="absolute right-0 mr-4 top-1/2 h-6 w-6 -translate-y-1/2 fill-primary-500 dark:fill-secondary-500"
        />
      )}
    </div>
  )
}

export default SelectExtraOptionsBottomsheet
